// extracted by mini-css-extract-plugin
module.exports = {"FacilitiesItem":"FacilitiesItem_FacilitiesItem__3-sev","Title":"FacilitiesItem_Title__1pOW3","Image":"FacilitiesItem_Image__39APG","active":"FacilitiesItem_active__6Ci6h"};